<template>
  <div id="app">
    <sidebar />
    <router-view/>
    <instagram-feed></instagram-feed>
    <Footer/>
    <music-player/>
  </div>
</template>

<script>
import InstagramFeed from '@/components/InstagramFeed.vue'
import Footer from '@/components/Footer'
import Sidebar from '@/components/Sidebar'
import MusicPlayer from './components/MusicPlayer.vue'
export default {
  name: 'App',
  components: {
    InstagramFeed,
    Footer,
    Sidebar,
    MusicPlayer
  },
  watch: {
    $route: {
      immediate: true,
      handler (to, from) {
        document.title = 'Gmnanashi - ' + to.meta.title
      }
    }
  },
  mounted () {
    if (this.$store.getters.isLoggedIn) { this.$store.dispatch('isUserLoggedIn') }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue